// extracted by mini-css-extract-plugin
export default {"quote":"Quote_quote___Sohc","text":"Quote_text__10uP0"};